import PriceSummary from "./PriceSummary";
import GuestCard from "./GuestCard";
import GuestForm from "./GuestForm";
import { calculate_age } from "../../helpers/general";
import { useState, useEffect } from "react";
import CONSTANTS from "../../Constants/Constants";

const HotelGuestsInfo = (props) => {

    const guests = [
        {
          "title": "mrs",
          "phone_number": "+442080160509",
          "type": "adult",
          "infant_passenger_id": "pas_00009hj8USM8Ncg32aMILY",
          "identity_documents": [
            {
              "unique_identifier": "19KL56147",
              "type": "passport",
              "issuing_country_code": "GB",
              "expires_on": "2025-04-25"
            }
          ],
          "id": "pas_00009hj8USM7Ncg31EMILY",
          "given_name": "Amelia",
          "gender": "f",
          "family_name": "Earhart",
          "email": "amelia@duffel.com",
          "born_on": "1987-07-24"
        },
        {
          "title": "mrs",
          "phone_number": "+17327999546",
          "identity_documents": [
            {
              "unique_identifier": "19KL56147",
              "type": "",
              "issuing_country_code": "GB",
              "expires_on": "2025-04-25"
            }
          ],
          "id": "pas_00009hj8USM7Ncg31HASANA",
          "given_name": "HASANA",
          "gender": "m",
          "family_name": "Mohammed",
          "email": "adinanaries@outlook.com",
          "type": "infant",
          "born_on": "2022-03-23"
        },
        {
          "title": "mrs",
          "phone_number": "+17327999546",
          "identity_documents": [
            {
              "unique_identifier": "19KL56147",
              "type": "",
              "issuing_country_code": "GB",
              "expires_on": "2025-04-25"
            }
          ],
          "id": "pas_00009hj8USM7Ncg31cMOHA",
          "given_name": "Mohammed",
          "gender": "m",
          "family_name": "Adinan",
          "email": "adinanaries@outlook.com",
          "born_on": "1992-03-23",
          "type": "adult",
        },
        {
          "title": "mrs",
          "phone_number": "+17327999546",
          "identity_documents": [
            {
              "unique_identifier": "19KL56147",
              "type": "passport",
              "issuing_country_code": "GB",
              "expires_on": "2030-04-25"
            }
          ],
          "id": "pas_00009hj8USM8Ncg32aTAFFA",
          "given_name": "Abdallah",
          "gender": "m",
          "family_name": "Mohammed",
          "email": "adinanaries@outlook.com",
          "born_on": "2021-03-23",
          "type": "child",
        },
        {
          "title": "mrs",
          "phone_number": "+17327999546",
          "identity_documents": [
            {
              "unique_identifier": "19KL56147",
              "type": "passport",
              "issuing_country_code": "GB",
              "expires_on": "2030-04-25"
            }
          ],
          "id": "pas_00009hj8USM8Ncg32MUQSIN",
          "given_name": "Muqsin",
          "gender": "m",
          "family_name": "Mohammed",
          "email": "adinanaries@outlook.com",
          "born_on": "1995-03-23",
          "type": "adult",
        }
    ]

    const UNSELECTED_GUEST_VALUE = -1;
    const PAGE_TITLES = {
        initial: {
            msg: "Please click on each guest card below to add their details..",
            icon: "fa-solid fa-info"
        },
        passenger_selected: {
            msg: "Please Provide Guest Information",
            icon: "fa-solid fa-user"
        }
    }

    const [ selectedGuestIndex, setSelectedGuestIndex ] = useState(UNSELECTED_GUEST_VALUE);
    const [ pageMsg, setPageMsg ] = useState(PAGE_TITLES.initial);
    const [ availableAdultPassengersForInfants, setAvailableAdultPassengersForInfants ] = useState([]);
    const [ allInfantsPassengers, setAllInfantPassengers ] = useState([]);

    const { 
        /*passengers, 
        prices, 
        resetCheckoutConfirmation,*/ 
        showGuestsPage,
        showPaymentPage,
        showDetailsPage,
    } = props;

    useEffect(()=> {
        setAdultPsngrForInfants();
        setInfantPsngr();
    }, []);

    const setAdultPsngrForInfants = () => {
        let temp_arr=[];
        guests.forEach( each => {
            if((calculate_age(each.born_on) > 17) || (each?.type?.trim()==="adult")) 
                temp_arr.push(each);
        });
        setAvailableAdultPassengersForInfants(temp_arr);
    }

    const setInfantPsngr = () => {
        let temp_arr=[];
        guests.forEach( each => {
            if(calculate_age(each.born_on) <= CONSTANTS.infant_age_threshold) 
                temp_arr.push(each);
        });
        setAllInfantPassengers(temp_arr);
    }

    const selectPassengerCard = (index) => {
        setSelectedGuestIndex(index);
        setPageMsg(PAGE_TITLES.passenger_selected);
    }

    const unSelectPassengerCard = () => {
        setSelectedGuestIndex(UNSELECTED_GUEST_VALUE);
        setPageMsg(PAGE_TITLES.initial);
    }

    const savePassengerInfo = (new_info_obj, index) => {
        props.savePassengerInfo(new_info_obj, index);
        unSelectPassengerCard();
        setAdultPsngrForInfants();
        setInfantPsngr();
    }


    return <div>
    <div className="checkout_page_all_info_flex_container">
        <div className="checkout_page_all_info_flex_left checkout_passengers_container" style={{borderTop: "1px solid rgba(0,0,0,0.1)"}} >
            <div style={{marginTop: 10}}>
                <p style={{color: "rgba(0,0,0,0.7)", fontSize: 13, fontFamily: "'Prompt', Sans-serif"}}>
                    <i className={pageMsg.icon} style={{marginRight: 10, color: "green"}}></i>
                    {pageMsg.msg}</p>
                <div style={{padding: "10px 0", display: "flex", flexWrap: "wrap", justifyContent: "space-between"}}>
                    
                    { ((selectedGuestIndex > UNSELECTED_GUEST_VALUE) && (selectedGuestIndex < guests.length)) ? 
                        <GuestForm 
                            index={selectedGuestIndex}
                            /*savePassengerInfo={savePassengerInfo}
                            resetCheckoutConfirmation={resetCheckoutConfirmation}*/
                            guest={guests[selectedGuestIndex]}
                            /*unSelectPassengerCard={unSelectPassengerCard}*/
                        /> :
                        guests.map((each, i) => {
                            let age = calculate_age(each.born_on);
                            return <GuestCard 
                                key={each.id}
                                index={i}
                                age={age}
                                /*setResponsibleAdultForInfant={props.setResponsibleAdultForInfant}
                                availableAdultPassengersForInfants={availableAdultPassengersForInfants}
                                allInfantsPassengers={allInfantsPassengers}*/
                                selectPassengerCard={selectPassengerCard} 
                                guest={each} 
                            />
                        })
                    }
                    
                </div>
            </div>
        </div>
        <div className="checkout_page_all_info_flex_right">
            <PriceSummary 
                prices={{}}
                backButtonFunction={showDetailsPage}
                buttonFunction={showPaymentPage} 
                buttonText="Payment"
                total_travelers={guests.length}
            />
        </div>
    </div>
</div>
}

export default HotelGuestsInfo;